import { userSetupUserInformationStyles } from "@insite/content-library/Widgets/UserSetup/UserSetupUserInformation";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design.surya";
import { css } from "styled-components";

userSetupUserInformationStyles.title = {
    variant: "h5",
    css: css`
        font-weight: 700;
        color: ${COLORS.text.main};
        font-family: ${TYPOGRAPHY.fontFamily.title};
        font-style: normal;
    `,
};
userSetupUserInformationStyles.wrapper = {
    css: css`
        padding-bottom: 15px;
        font-family: ${TYPOGRAPHY.fontFamily.title};
        div[class^="FormFieldStyle"] {
            label {
                color: ${COLORS.text.main};
                font-family: ${TYPOGRAPHY.fontFamily.title};
            }
        }
    `,
};
